export default () =>
  import(
    /* webpackChunkName: 'coffee/app/mastercard/wait-info' */ './WaitInfo'
  );
